/*
 * Copyright (c) 2025, Wultra s.r.o. (www.wultra.com).
 *
 * All rights reserved. This source code can be used only for purposes specified
 * by the given license contract signed by the rightful deputy of Wultra s.r.o.
 * This source code can be used only by the owner of the license.
 *
 * Any disputes arising in respect of this agreement (license) shall be brought
 * before the Municipal Court of Prague.
 */

import type { LoggerStore } from "../../logger/logger-store"
import type { Result } from "../../network/http-client"
import { makeGetRequest } from "../../network/http-client"

import type { ApplicationStore } from "./application-store"
import type { ApplicationStatus, PageApplicationList } from "./application-types"

enum Endpoint {
    application = "/api/private/application"
}

export class ApplicationService {
    private readonly PAGE_SIZE = 50

    constructor(
        private readonly store: ApplicationStore,
        private readonly logger: LoggerStore
    ) {}

    async getApplications(
        appTypeId: number,
        status: ApplicationStatus,
        flags: string[],
        page: number = 0
    ): Promise<Result<PageApplicationList>> {
        const params = {
            applicationTypeId: `${appTypeId}`,
            status: `${status}`,
            flags: `${flags}`,
            page: `${page}`,
            size: `${this.PAGE_SIZE}`
        }
        const response = await makeGetRequest<PageApplicationList>(Endpoint.application, params)

        if (response.success && response.data) {
            this.store.setApplications({ appTypeId, status, flags, page }, response.data)
            return response
        }

        if (!response.success) {
            this.logger.logApiError("Get applications failed", response.apiError, response.error)
        }

        return response
    }
}
